export default __webpack_public_path__ + "static/media/iStore.34566afe.svg";